const route = () => `/cart`;

export default route;
